import React, { Component } from "react";
import './InitialFormStyleSheet.css';


class InitialFormHeader extends Component {

    render() {
        return (
            <div className="s360-initial-form-header" >
                <div className="s360-initial-form-header-message" style={this.headerStyle()} >
                    {this.props.config.configDetails.brandMessage.split("\n").map(messageItem => {
                        return (<>
                            {messageItem}
                            <br />
                        </>)
                    })
                    }
                </div>
            </div>
        )
    }

    headerStyle = () => {
        return {
            color:      this.props.config.designDetails.headerFontColor,
            fontFamily: this.props.config.designDetails.headerFont,
            fontSize:   this.props.config.designDetails.headerFontSize,
        }
    }
}

export default InitialFormHeader;
